import myAxios from "@/utils/request";
export default {
  getList(params) {
    return myAxios.post("/api/requirement/reqpaging_rtat", params);
  },
  beforeBatchDelete(params) {
    return myAxios.post("/api/requirement/achiexistproject", params);
  },
  batchDelete(params) {
    return myAxios.post("/api/requirement/backbatchdelete", params);
  },
  // 添加需求详情
  addDem(params) {
    return myAxios.post("/api/requirement/topaddreq_im", params);
  },
  // 修改需求详情
  modifyDem(params) {
    return myAxios.post("/api/requirement/topaddreq_im", params);
  },
  // 审核需求详情
  auditDem(params) {
    return myAxios.post("/api/requirement/appreq_im", params);
  },
  // 获取需求详细信息
  getDemInfo(params) {
    const { id } = params;
    return myAxios.get("/api/requirement/getreqbyid_im?id=" + id);
  }
};
